{
  "add": "Add",
  "add-barn-first-description": "First register barns in your settings. After that you can register the arrival here.",
  "add-cycle": "Add cycle",
  "add-day-old-chick-first-description": "First register an arrival. After that you can register the departure here.",
  "age": "Age",
  "amount": "Amount",
  "app": {
    "cycles": "Cycles",
    "deliveries": "Deliveries",
    "reports": "Reports",
    "settings": "Settings",
    "products": "Products",
    "farmer-insights": "Farmer Insights",
    "advices": "Advice & Reference",
    "feed-advice": "Feed Advice",
    "reference-value-sheet": "Reference Value Sheet",
    "standard-reference-value-sheet": "Standard Reference Value Sheets",
    "reference-scheme": "Reference Feed Advices",
    "management": "Management",
    "performance": "Performance",
    "within-cycle-performance": "Within Cycle Performance"
  },
  "farmer-insights": {
    "kpiGroups": {
      "TechnicalPerformance": "Technical performance",
      "FinancialPerformance": "Financial performance",
      "ArrivalAndDeparture": "Arrival & departure",
      "FeedConsumption": "Feed consumption",
      "WellBeing": "Well-being",
      "RevenueAndCost": "Revenue & costs"
    },
    "description": "Realtime insights into the status of your farm!",
    "locations": "Locations",
    "location": "Location",
    "cycles": "Cycles",
    "barns": "Barns",
    "detail-level": "Detail level",
    "display-type": "Display",
    "kpis-name": "KPIs",
    "table": "Table",
    "chart": "Chart",
    "kpi-selection": "KPI selection",
    "aggregation": {
      "Sum": "Cumulative",
      "Average": "Average",
      "Min": "Min",
      "Max": "Max"
    },
    "custom-footers": {
      "end-total": "End total",
      "same-period": "<Tenant> same period (flocks:",
      "last-weeks": "<Tenant> last 10 weeks (flocks:",
      "customer-average-selected-period": "Customer average selected period (flocks:"
    },
    "no-data": {
      "title": "No Insights data available",
      "description": "Insights data is shown when one or more flocks are available."
    },
    "no-benchmark": "Insufficient data to determine (minimum of 15 flocks is needed).",
    "benchmark-title": "<Tenant>",
    "benchmark-selected-period": "selected period",
    "benchmark-last-weeks": "last 10 weeks",
    "norm": "norm",
    "benchmark-settings": "Benchmark settings",
    "settings": {
      "header": "Filters",
      "title": "Benchmark settings",
      "subtitle": "Here you can set with which benchmark you want to compare your flocks if you are not in 'detailed' mode",
      "selected-period-label": "Display <Tenant> benchmark for the selected period",
      "last-weeks-label": "Display <Tenant> benchmark for the last 10 weeks",
      "customer-average-selected-period-label": "Display customer average for selected period",
      "none": "None",
      "select-multiple-benchmark-label": "You can select multiple benchmarks",
      "select-one-benchmark-label": "You can only select one benchmark",
      "non-detailed-view-label": "Non-detailed views",
      "detailed-view-label": "Detailed views"
    },
    "reset-filters": "Restore KPI selection",
    "to": "to",
    "maxPrintWarning": {
      "title": "Warning",
      "message": "You have selected more than the max number of KPI's you're able to print. Only the first number of KPI's able to print will be shown when printing. Current possible number of KPI's when printing:"
    },
    "kpis": {
      "DayOldChicks": "Number of chicks",
      "DayOldChicksPrice": "Chick arrival price",
      "TotalDeparture": "Total departure",
      "DepartureWeight": "Departure weight",
      "SlaughterWeight": "Slaughter weight",
      "Revenue": "Revenue",
      "FeedBalance": "Feed consumption",
      "FeedBalancePrice": "Feed consumption price",
      "LossPercentage": "Loss Percentage",
      "ReplacementPercentage": "Replacement percentage",
      "FeedConversion": "Feed conversion",
      "FeedConversion1500": "Feed conversion 1500",
      "AverageWeightInGram": "Average weight",
      "WeightedAverageAgeInDays": "Average weighted age",
      "WeightedAverageGrowthPerDay": "Growth",
      "ProductionNumber": "Production number",
      "DayOldChicksPerSquareMeter": "Number of chicks per m²",
      "FeedUsageInKgPerSquareMeter": "Feed consumption per m²",
      "FeedConsumptionPricePer100Kg": "Feed consumption price per 100 kg",
      "PaidAmountPerKg": "Revenue per kg",
      "NettoRevenue": "Netto Revenue",
      "NettoRevenuePerChick": "Netto Revenue per chick",
      "NettoRevenuePerSquareMeterPerDay": "Netto Revenue per m² per day",
      "RejectionRate": "Rejection Rate",
      "PricePerDayOldChick": "Price per day old chick",
      "FeedBalanceMixProduct": "Feed consumption Mixed Products",
      "FeedBalanceRawProduct": "Feed consumption Raw Products",
      "DeliveredKgPerSquareMeter": "Delivered kg per m²",
      "NettoRevenuePerSquareMeter": "Netto Revenue per m²",
      "FeedConsumptionPerDeliveredKg": "Feed costs per delivered kg",
      "DayOldChicksWeight": "Chick weight",
      "WeightedHeelDermatitis": "Weighted Heel Dermatitis",
      "WeightedFootpadLesionNonePercentage": "Weighted FPD 0",
      "WeightedFootpadLesionModeratePercentage": "Weighted FPD 1",
      "WeightedFootpadLesionSeverePercentage": "Weighted FPD 2",
      "TotalLoss": "Loss",
      "WeightedFootpadLesionScore": "Weighted FPD Score",
      "FeedBalanceRawPrice": "Feed consumption Raw Products Price",
      "FeedBalanceMixPrice": "Feed consumption Mixed Products Price",
      "PartialDeparture": "Partial departure",
      "FullDeparture": "Full departure",
      "NettoProfitInclOtherCosts": "Netto profit including other costs",
      "DayOldChicksPriceExclDiscounts": "Chick arrival price excl. discounts",
      "RevenueExclDiscounts": "Revenue excl. discounts",
      "FeedBalancePriceExclDiscounts": "Feed consumption price excl. discounts"
    },
    "data-view-types": {
      "PerLocation": "Per Location",
      "PerCycle": "Per Cycle",
      "PerCycleBarn": "Per Cycle Per Barn",
      "PerLocationBarn": "Per Barn"
    },
    "customer-average-selected-period": "Customer average selected period",
    "show-more": "show more",
    "show-less": "show less"
  },
  "within-cycle-performance": {
    "advice_and_reference-value-sheet": "Feed advice & Reference value sheet",
    "kpi": "KPI",
    "kpis": {
      "IndoorTemperature": "Indoor temperature",
      "IndoorHumidity": "Indoor humidity",
      "MortalityPercentage": "Mortality%",
      "FeedIntakePerChick": "Feed intake (per chick)",
      "WaterIntakePerChick": "Water intake (per chick)",
      "WeightGainPerChick": "Weight gain (per chick)",
      "WaterToFeedRatio": "Water:feed ratio",
      "FeedConversionRate": "Feed conversion rate",
      "LitterQuality": "Litter quality",
      "LitterQualityCaked": "Caked",
      "LitterQualityLoose": "Loose",
      "LitterQualityWet": "Wet",
      "BodyWeight": "Body weight",
      "GrowthPrediction": "Growth prediction",
      "IndoorOutdoorTemperature": "Indoor / Outdoor temperature",
      "IndoorOutdoorHumidity": "Indoor / Outdoor humidity",
      "OutdoorTemperature": "Outdoor temperature",
      "OutdoorHumidity": "Outdoor humidity"
    },
    "no-data": "No data available."
  },
  "area": "Area",
  "arrival-date": "Arrival date",
  "avined": "Avined",
  "balance": {
    "add-manual-delivery": "Add delivery",
    "balance-row": "Balance row",
    "barn-distribution": {
      "available-in-this-cycle": "Available within this cycle",
      "change-flock-allocation": "Change flock allocation",
      "currently": "Currently:",
      "delivery-line-info": "Delivery line information",
      "flock-allocation": "Flock allocation",
      "kg-per-chick": "kg/day old chick",
      "of-which-remaining": "Of which remaining",
      "total-should-be": "The sum of all quantities should be",
      "totally-delivered": "Totally delivered",
      "usage-in-kg": "Usage (kg)",
      "usage-in-other-cycles": "Usage in other cycles",
      "usage-in-this-cycle": "Usage within this cycle",
      "total": "Total",
      "totalRaw": "Total raw feed",
      "totalCompound": "Total compound feed"
    },
    "consumption": "Consumption (kg)",
    "delivery-date": "Delivery Date",
    "empty-day-old-chick-description": "First register an arrival. After that you can add the balance rows here.",
    "empty-day-old-chick-title": "No deliveries",
    "empty-description": "Click 'Recalculate' to show the balance.",
    "empty-title": "No balance rows were found",
    "manual-add": "Manual",
    "multiple-deliveries": "Multiple deliveries",
    "price": "Price",
    "product": "Product",
    "quantity": "Quantity (kg)",
    "recalculate": "Recalculate",
    "recalculate-warning": {
      "text": "All feed deliveries for the current cycle will be reloaded. Any new deliveries will be added. All remaining quantities will be set to zero.",
      "title": "Are you sure you want to recalculate?"
    },
    "remainder": "Remainder (kg)",
    "remainder-greater-than-quantity": "The remainder cannot be greater than the quantity.",
    "remainder-less-than-zero": "The remainder cannot be less than 0.",
    "remainder-less-than-quantity": "The remainder cannot be less than the quantity.",
    "remainder-greater-than-zero": "The remainder cannot be greater than 0.",
    "remainder-other-than-zero": "The remainder cannot be other than 0.",
    "remainder-NaN": "The remainder is not a valid number.",
    "pending-changes-warning": {
      "title": "Unsaved changes",
      "message": "You have unsaved changes in your balance.",
      "confirmText": "Continue without saving",
      "cancelText": "Cancel"
    },
    "save-confirm": {
      "title": "Save balance",
      "text": "The balance has not yet been finalized. By saving and making final, you can give the balance the status “final”. If the balance is not yet complete, you should choose 'save'. With this you can save the balance with status “preliminary”.",
      "alert": "Finalizing the balance is important, because only then will the round be considered complete in the reports."
    },
    "edit-confirm": {
      "title": "Edit balance",
      "text": "If you choose to change balance, the status of the balance will change from “final” to “preliminary”. You can then make your changes and make the balance final again.",
      "alert": "Re-finalizing the balance after the changes is important, because a round with a preliminary balance will not be considered complete in the reports."
    },
    "not-finalized": {
      "title": "Balance is not finalized yet",
      "message": "The balance has not yet been finalized. With 'Save and finalize' you can immediately finalize the balance."
    },
    "save-and-finalize": "Save and finalize",
    "save": "Save",
    "edit": "Edit",
    "edit-balance": "Edit balance",
    "delete-confirm": {
      "text": "This will remove the delivery from your list. Deliveries that have been used in balances cannot be removed.",
      "title": "Are you sure you want to remove this delivery?"
    },
    "has-empty-barns": {
      "title": "Faulty balance rows found",
      "message": "Balance rows were found where no barn was set. This problem will be solved by recalculating the balance."
    },
    "barn-name": "Barn",
    "invoice-date": "Invoice date",
    "invoice-number": "Invoice number",
    "delivery-number": "Delivery ID"
  },
  "balance-item": {
    "add-product": "Add manually",
    "error-product-selected": "Select a product",
    "no-products": "No existing products found.",
    "product": "Product"
  },
  "balance-item-delivery": {
    "amount": "Amount per barn",
    "current-usage": "Current usage",
    "error-amount": "Enter the amount",
    "error-no-amount": "Enter the amount for at least one barn.",
    "remaining-of": "remaining of"
  },
  "balance-item-manual": {
    "amount": "Amount per barn",
    "delivery-date": "Delivery date",
    "error-amount": "Enter the amount",
    "error-delivery-date": "Enter the delivery date",
    "error-no-amount": "Enter the amount for at least one barn.",
    "error-price": "Enter the net price",
    "error-product-title": "Enter the product description",
    "error-supplier-name": "Enter the supplier name",
    "error-vat": "Enter the VAT percentage",
    "price": "Net price (excl. VAT)",
    "product-title": "Product description",
    "product-type-multiple": "Mixed product",
    "supplier-name": "Supplier name",
    "vat": "VAT"
  },
  "balance-summary": {
    "consumption-per-delivered-chick": "Consumption/Delivered Chick",
    "final-stock": "Final Stock (kg)",
    "initial-stock": "Initial Stock (kg)",
    "title": "Balance Summary",
    "total": "Total Consumption (kg)",
    "delivery-stock": "Delivery (kg)",
    "product": "Product"
  },
  "barn": "Barn",
  "barn-item": {
    "area": "Surface area",
    "error-name-duplicate": "This barn name is already in use. Enter a unique barn name",
    "error-name-required": "Enter the barn name",
    "error-surface-area": "Enter the surface area",
    "name": "Barn description",
    "animal-group-barn-id": "Animal Group Barn Id",
    "not-mapped": "(Not Mapped)"
  },
  "birth-date": "Date of birth",
  "breed": "Breed",
  "cadaver": "Cadaver",
  "catching": "Catching",
  "certification": "IKB",
  "chick-price": "Net price per chick, excl. VAT",
  "chickens": "Chickens",
  "chicks-parents-age-in-weeks": "Parents Age (in weeks)",
  "chicks-weight-in-grams": "Chicks weight (in grams)",
  "close-round": "Close cycle",
  "concept": "Concept",
  "costs": "Costs",
  "costs-specification": "Cost specification",
  "couple": "Flock",
  "couple-number": "Nr",
  "couples": "Flocks",
  "customer-id": "Customer ID",
  "cycle": "Cycle",
  "cycle-navigation": {
    "balance": "Balance",
    "closure": "Closure",
    "day-old-chick": "Delivery",
    "departure": "Departure",
    "general": "General"
  },
  "cycle-number": "Nr.",
  "enter-amounts": "Enter amounts",
  "n/a": "n/a",
  "cycle-overview": {
    "barn": "Barn",
    "consumption-empty": {
      "description": "Add feed usage to see balance rows here.",
      "title": "There are no balance rows."
    },
    "daily-performance-empty": {
      "description": "Add Supply to make weekly / daily observations available.",
      "title": "Entry not available."
    },
    "cycle": "Cycle",
    "delete-cycle": "Delete",
    "edit-current-week": "Capture weekregistrations",
    "weekregistration-overview": "Weekregistrations Overview",
    "detailedOverview": "Detailed",
    "edit": "edit",
    "edit-cycle": "Edit",
    "option-all-barn": "- all barns -",
    "panel": {
      "add-day-old-chick": "add arrival",
      "add-departure": "Add departure",
      "amount": "Amount",
      "balance-overview": "Balance overview",
      "balance-title": "Feed Consumption",
      "birthdate": "Birthdate",
      "consumption": "Consumption (kg)",
      "consumption-per-chick": "Consumption p.d.c. (g)",
      "date": "Delivery Date",
      "day-old-chick-overview": "Arrival overview",
      "day-old-chick-title": "Arrival",
      "day-old-chick-total": "Total arrival",
      "departure-overview": "Departure overview",
      "departure-title": "Departure",
      "departure-total": "Total departure",
      "departuredate": "Departure Date",
      "departureweight": "Departure weight",
      "price": "Price",
      "price-ex-vat-per-chick": "Price per chick (excl. VAT)",
      "price-ex-vat": "Price (excl. VAT)",
      "product-title": "Feed name",
      "product-type-mixedproduct": "Compound",
      "product-type-rawproduct": "Raw",
      "revenue": "Revenue",
      "slaughterweight": "Payout weight",
      "type": "Type",
      "type-full": "Full disposal",
      "type-manual": "Manual",
      "type-partial": "Partial disposal",
      "type-platform": "Platform",
      "type-start": "Platform",
      "total-consumption": "Total consumption",
      "daily-performance-title": "Weekly and Daily Observation Registrations",
      "edit-current-week": "Capture weekregistrations",
      "cycle-title": "Cycle",
      "discount-title": "Discounts",
      "discount-overview": "Discount overview"
    },
    "placeholder": "- make a selection -",
    "start-new-cycle": "Start new cycle",
    "weekregistration-download": "Download template",
    "weekregistration-upload": "Import",
    "weekregistration-select-file": "Select file...",
    "weekregistration-upload-csv-title": "Select a CSV file to import",
    "upload-csv-message": "Columns should not be removed from the template, even if they are empty. Fields can be left empty.",
    "upload-csv-notification": "Select a CSV file to import",
    "weekregistration-select-interval-type": "Interval type",
    "download-weekly-report": "Weekly report",
    "cycle-start-in-future-warning-description": "The start date of this cycle is in the future. Because of that, it is not possible to register observations.",
    "cycle-start-in-future-warning-title": "Cycle not started yet"
  },
  "wdo-labels": {
    "mortality": "Mortality number",
    "feedIntake": "Feed intake",
    "waterIntake": "Water intake",
    "indoorTemperature": "Indoor temperature (°C)",
    "outdoorTemperature": "Outdoor temperature (°C)",
    "indoorHumidity": "Indoor humidity (%)",
    "outdoorHumidity": "Outdoor humidity (%)",
    "weight": "Weight (g)",
    "litterQuality": "Litter quality",
    "litterQualities": {
      "Loose": "Litter quality loose (%)",
      "Caked": "Litter quality caked (%)",
      "Wet": "Litter quality wet (%)"
    },
    "selection": "Selection",
    "selectionSmall": "Selection small",
    "selectionLegProblems": "Selection leg problems",
    "feedIntakeGramPerBird": "Feed intake (Gram per animal)",
    "feedIntakeKg": "Feed intake (Kg)",
    "waterIntakeMililiterPerBird": "Water intake (Ml per animal)",
    "waterIntakeL": "Water intake (L)",
    "kilogramSuffix": "Kg",
    "gramSuffix": "Gram",
    "literSuffix": "L",
    "mililiterSuffix": "Ml",
    "ageInDays": "Age in days"
  },
  "wdo-settings": {
    "title": "Weekly and daily observations settings",
    "disabled-message": "These settings cannot be changed because week registrations have been entered.",
    "startday-description": "Starting day in context to the arrival date of the flocks",
    "startday-label": "Weekday setting",
    "startday-placeholder": "- select a starting day -",
    "weekly-daily-description": "You can determine here what information you want to enter daily or weekly.",
    "open-settings": "Open settings",
    "general-option": {
      "label": "General settings",
      "per-day": "Per day for all",
      "per-week": "Per week for all"
    },
    "setting-option": {
      "off": "Off",
      "per-day": "Per day",
      "per-week": "Per week"
    },
    "delete-confirm": {
      "title": "Are you sure you want to change this settings?",
      "text": "This will delete the data for the following indicators upon saving; "
    }
  },
  "wdo-registration": {
    "all-settings-are-off-title": "All registration fields have been switched off.",
    "all-settings-are-off-message": "First go to the Weekly and daily observations settings on the General-tab in this cycle and set up your settings there.",
    "registration": "Weekly and daily observations registrations",
    "cycle-date": "Arrival date",
    "cycle-end-date": "Cycle end date",
    "select-week": "Week",
    "select-week-placeholder": "- select a week -",
    "select-barn": "Barn",
    "select-barn-placeholder": "- select a barn -",
    "validation-errors": {
      "total-must-be-100": "The total of the litter quality combined should be 100%.",
      "date-is-not-valid-title": "Incorrect dates in upload file",
      "date-is-not-valid-description": "There is data in the upload file with a day/week that is larger/smaller than the cycle enddate/startdate. The data with the correct date is saved."
    },
    "next-day": "Next day"
  },
  "wdo-registration-overview": {
    "title": "Observation Registrations Overview",
    "weekly-registrations": "Weekly Observation Registrations",
    "daily-registrations": "Daily Observation Registrations",
    "columns": {
      "weeknr": "Week",
      "date": "Date"
    },
    "no-observations-found": {
      "title": "No observations found",
      "message": "No weekly or daily observations have been entered for this cycle."
    }
  },
  "chicks": "Chicks",
  "cycles": "Cycles",
  "dashboard": "Dashboard",
  "date": "Date",
  "date-of-arrival": "Date of arrival",
  "day-old-chicks": "Day old chicks",
  "days": "Days",
  "decontamination": "Decontamination",
  "delete": "Delete",
  "delete-item-balance": "Do you want to delete the balance row?",
  "delete-item-barn-item": "Do you want to delete the barn?",
  "delete-item-day-old-chick": "Do you want to delete the delivery?",
  "delete-item-departure": "Do you want to delete the departure?",
  "delete-item-flock-cycle": "Do you want to delete the flock cycle?",
  "delivery": {
    "deliveries": "Deliveries",
    "delivery": "Delivery"
  },
  "delivery-item": {
    "amount": "Amount per barn",
    "delivery-date": "Delivery date",
    "error-amount": "Enter the amount",
    "error-delivery-date": "Enter the delivery date",
    "error-no-amount": "Enter the amount for at least one barn.",
    "error-price": "Enter the net price",
    "error-product-title": "Enter the product description",
    "error-supplier-name": "Enter the supplier name",
    "error-units-delivered": "Enter units delivered",
    "error-units-delivered-not-enough": "A part of this delivery has already been used in balances of cycles. You therefore need a minimum of:",
    "error-vat": "Enter the VAT percentage",
    "external-product-id": "Product reference number",
    "manual-delivery": "Manual Delivery",
    "price": "Net price (excl. VAT)",
    "product-title": "Product description",
    "product-type-multiple": "Mixed product",
    "supplier-name": "Supplier name",
    "units-delivered": "Units delivered",
    "vat": "VAT",
    "price-per-100kg": "Net price per 100 kg (excl. VAT)",
    "error-price-per-100kg": "Enter the net price per 100 kg",
    "barn": "Barn",
    "invoice-date": "Invoice date",
    "invoice-number": "Invoice number",
    "vat-percentage": "VAT Percentage"
  },
  "delivery-overview": {
    "active": "Active",
    "delivery": "Delivery",
    "delivery-lines": "Delivery lines",
    "display-in-cycle": "Display in cycle",
    "no-deactivation": {
      "description": "A cycle exists in which this delivery is used.",
      "title": "Deactivation not possible"
    },
    "no-deliveries": {
      "description": "Deliveries are added automatically and will be displayed here.",
      "title": "No deliveries for the selected period"
    },
    "remaining-of": "remaining of",
    "remove-delivery-warning": {
      "text": "This will remove the delivery from your list. Deliveries that have been used in balances cannot be removed.",
      "title": "Are you sure you want to remove this delivery?"
    },
    "table": {
      "deliveryDate": "Delivery date",
      "deliveryId": "Delivery ID",
      "product": "Product",
      "isActive": "Active",
      "showInFinalSetup": "Show in Final Setup",
      "invoiceDate": "Invoice date",
      "invoiceNumber": "Invoice number"
    }
  },
  "departure": {
    "barn": "Barn",
    "empty-day-old-chicks-description": "Add a delivery and it will show up here.",
    "empty-day-old-chicks-title": "No deliveries",
    "empty-description": "Add a departure and it will show up here.",
    "empty-title": "No departures"
  },
  "departure-date": "Departure date",
  "departure-item": {
    "age": "Age",
    "amount-of-chicks": "Amount",
    "average-weight": "Average weight PAK",
    "barn": "Barn",
    "chicks": "chicks",
    "date": "Date",
    "error-amount-of-chicks-max": "The maximum amount of chicks is:",
    "error-amount-of-chicks-min": "Add at least one chick",
    "error-amount-of-chicks-required": "Enter the amount of chicks",
    "error-barn": "Select the barn",
    "error-date": "Enter the departure date. This must be after the earliest arrival date, but not in the future.",
    "error-no-chicks-remaining": "There are no chicks left for departure",
    "error-type": "Enter the type of departure",
    "footpad-lesion-score": "Footpad lesion score",
    "footpad-lesion-none": "Score 0",
    "footpad-lesion-moderate": "Score 1",
    "footpad-lesion-severe": "Score 2",
    "footpad-lesion-validation": "The percentages in Score 0, 1 and 2 must add up to exactly 100%.",
    "heel-dermatitis": "Heel dermatitis",
    "revenue": "Total revenue (excl. VAT)",
    "slaughter-results": "Slaughter results",
    "slaughter-weight": "Total slaughter weight",
    "rejection-at-slaughterhouse": "Rejection at slaughterhouse",
    "rejection-during-transport": "Rejection during transport",
    "slaughterhouse": "Slaughterhouse",
    "type": "Type",
    "type-full": "Full disposal",
    "type-partial": "Partial disposal",
    "weight": "Departure weight",
    "weight-validation": "Total slaughter weight cannot be higher than departure weight.",
    "diverseCosts": "Diverse costs",
    "revenueSubTotal": "Revenue (excl. VAT)"
  },
  "departure-title": "Departure",
  "departure-type-full": "Full",
  "departure-type-partial": "Partial",
  "download-pdf": "Download PDF",
  "edit": "Edit",
  "electricity": "Electricity",
  "error-amount-of-chickens": "Enter the amount of chickens",
  "error-amount-of-chicks": "Enter the amount of day old chicks",
  "error-amount-of-chicks-too-big": "Amount of day old chicks is too high",
  "error-arrival-date": "Enter the arrival date",
  "error-barn-selected": "Select the barn",
  "error-breed": "Select the breed",
  "error-chick-birth-date": "Enter the date of birth",
  "error-chick-price": "Enter the price per day old chick",
  "error-concept": "Select the concept",
  "error-cycle-number": "Enter a unique cycle number",
  "error-hatchery": "Select the hatchery",
  "error-start-date": "Enter the start date",
  "error-surface-area": "Enter the surface area",
  "error-total-costs": "Enter the total costs",
  "error-total-price": "Enter the amount",
  "feed": "Feed",
  "flocks": "Flocks",
  "general": "General",
  "grams": "grams",
  "hatchery": "Hatchery",
  "healthcare": "Healthcare",
  "heating": "Heating",
  "litter": "Litter",
  "management": "Management",
  "manure": "Manure",
  "no-barns-description": "Add a barn and it will show up here.",
  "no-barns-title": "No barns",
  "no-cycle-selected-description": "Select a round to see its information.",
  "no-cycle-selected-title": "A cycle has not been selected",
  "no-cycles-description": "Add a cycle and it will show up here.",
  "no-cycles-title": "No cycles",
  "no-day-old-chicks-description": "Add a delivery and it will show up here.",
  "no-day-old-chicks-title": "No deliveries",
  "no-departures-description": "Add a departure and it will show up here.",
  "no-departures-title": "No departures",
  "none": "None",
  "nr": "Nr.",
  "number-of-day-old-chicks": "Amount",
  "other": "Other",
  "print": "Print",
  "remove-cycle": "Remove cycle",
  "report-navigation": {
    "barn-report": "Barn overview"
  },
  "report-overview": {
    "barn": "barn",
    "barn-report": "Barn overview",
    "barn-report-loading": "is being generated...",
    "cycle": "Cycle",
    "reports": "Reports",
    "cycle-closed": "(Cycle finished)"
  },
  "save-as-concept": "Save as concept",
  "settings": "Settings",
  "settings-navigation": {
    "barns": "Barns",
    "observationsetting": "Observations",
    "rvssetting": "Reference Value Sheets",
    "farmresultsetting": "FarmResult",
    "performance": "Performance",
    "finalsetupsetting": "Final Setup",
    "discountsetting": "Discounts",
    "sustainabilitysetting": "Sustainability"
  },
  "observations-setting": {
    "description": "Do you want to track cycle performance on a weekly and daily basis?",
    "switch": "Activate weekly/daily observations"
  },
  "column-setting": {
    "title": "Column settings",
    "description": "Columns"
  },
  "rvs-setting": {
    "title": "Reference value sheets settings",
    "temperatureInside-option": {
      "label": "Temperature",
      "Celcius": "Celcius",
      "Fahrenheit": "Fahrenheit",
      "short": {
        "Celcius": "(°C)",
        "Fahrenheit": "(F)"
      }
    },
    "feedIntake-option": {
      "label": "Feed",
      "Gram": "Gram",
      "Kilogram": "Kilogram",
      "short": {
        "Gram": "(g)",
        "Kilogram": "(kg)"
      }
    },
    "waterIntake-option": {
      "label": "Water",
      "ML": "Milliliter",
      "DL": "Deciliter",
      "L": "Liter",
      "short": {
        "ML": "(ml)",
        "DL": "(dl)",
        "L": "(l)"
      }
    },
    "weight-option": {
      "label": "Weight",
      "Gram": "Gram",
      "Kilogram": "Kilogram",
      "short": {
        "Gram": "(g)",
        "Kilogram": "(kg)"
      }
    },
    "dayoffset": {
      "title": "Start day setting",
      "label": "Start day"
    }
  },
  "specify-costs": "Specify costs",
  "start-date": "Start date",
  "title": "PoultryNEXT",
  "title_Agrifirm": "PoultryNEXT",
  "title_Agravis": "Avidata broiler",
  "total-costs": "Total costs",
  "total-price": "Amount, excl. VAT",
  "unspecified-costs": "Unspecified costs",
  "water": "Water",
  "water-additives": "Water additives",
  "weeks": "weeks",
  "search": "Search",
  "dateFrom": "From",
  "dateTo": "To",
  "days-of-week": {
    "Monday": "monday",
    "Tuesday": "tuesday",
    "Wednesday": "wednesday",
    "Thursday": "thursday",
    "Friday": "friday",
    "Saturday": "saturday",
    "Sunday": "sunday"
  },
  "unitOfMeasure": {
    "g/day": "g/day",
    "€/m²/day": "€/m²/day",
    "$/m²/day": "$/m²/day",
    "£/m²/day": "£/m²/day",
    "zł/m²/day": "zł/m²/day",
    "Ft/m²/day": "Ft/m²/day"
  },
  "feed-advice": {
    "overview": {
      "title": "Feed Advice Overview",
      "empty": {
        "title": "Feed advice items unavailable",
        "description": "There are no feed advice items available at this moment."
      },
      "table-header": {
        "name": "Name",
        "created": "Created",
        "updated": "Updated",
        "updatedAdvisorName": "Updated by",
        "isActive": "Active"
      },
      "buttons": {
        "add": "Create Feed Advice",
        "edit": "Edit",
        "delete": "Delete"
      }
    },
    "create-from-reference": {
      "title": "Create Feed Advice",
      "scratch-title": "Start from scratch",
      "scratch-option-title": "Start a feed advice",
      "scratch-button": "Start from scratch",
      "scratch-option-subtitle": "This is an empty feed advice",
      "reference-schemes-title": "Choose a reference feed advice as base",
      "reference-schemes-button": "Start with ",
      "product": "Product",
      "products": "Products",
      "additive": "Additive",
      "additives": "Additives"
    },
    "dialog": {
      "deleteConfirm": "Are you sure you want to delete this feed advice?",
      "deleteConfirmWhenInUse": "This feed advice is linked to a cycle, are you sure you want to delete this feed advice?"
    },
    "create": {
      "print": "Print",
      "title": "Feed advice",
      "name": "Feed advice name",
      "error-name": "A name for the feed advice is required.",
      "description": "Description",
      "description-placeholder": "Feed advice description",
      "product-placeholder": "- select a product -",
      "add-product": "Add product",
      "table-header": {
        "productName": "Product",
        "chickenWeightInGrams": "Chick weight (g)",
        "ageFrom": "Age from (days)",
        "ageTo": "Age to (days)",
        "totalFeed": "Feed intake (g)",
        "coreFeed": "Core (g)",
        "wheatFeed": "Wheat (g)",
        "comment": "Comments",
        "age": "Age (days)",
        "coreFeedTons": "Core (tons)",
        "wheatFeedTons": "Wheat (tons)",
        "dosage": "Dosage (kg/tonne)",
        "applicationMoment": "Application moment"
      },
      "created": "Created",
      "updated": "Updated",
      "number-of-day-old-chicks": "Number of day old chicks",
      "validation-error": {
        "title": "Validation error(s)",
        "feedadvice-name": "Feedadvice name is required",
        "age-from": "Age from is required",
        "chicken-weight": "Chicken weight is required",
        "product": "Product is required",
        "total-feed": "Total feed is required",
        "age-to": "Age to is required (except in the last line)",
        "age-min-max": "Age From should be lower than Age To."
      },
      "products": "Base advice",
      "additives": "Additives",
      "show-additives": "Show additives",
      "add-additive": "Add addition"
    },
    "print": {
      "farmcompany": "Company",
      "customernr": "Customer Number",
      "contactperson": "Contactperson",
      "location": "Location",
      "customerservice": "Customer Service",
      "table-header": {
        "productName": "Product",
        "chickenWeightInGrams": "Chick weight",
        "age": "Age",
        "totalFeed": "Feed intake",
        "coreFeed": "Core",
        "wheatFeed": "Wheat",
        "comment": "Comments",
        "gramPerChick": "Gram/Chick",
        "orderQuantity": "Order Quantity (ton)",
        "units_gram": "(g)",
        "units_days": "(days)",
        "dosage": "Dosage",
        "units_kgton": "kg/tonne",
        "applicationMoment": "Application moment"
      }
    }
  },
  "standard-reference-value-sheet": {
    "overview": {
      "title": "Standard Reference Value Sheets Overview"
    },
    "create": {
      "title": "Standard Reference Value Sheet"
    }
  },
  "reference-value-sheet": {
    "overview": {
      "title": "Reference Value Sheets Overview",
      "empty": {
        "title": "Reference Value Sheet data not available",
        "description": "There is no Reference Value Sheet data available at the moment."
      },
      "table-header": {
        "name": "Name",
        "created": "Created",
        "updated": "Updated",
        "updatedAdvisorName": "Updated by",
        "isActive": "Active"
      },
      "buttons": {
        "add": "Add Reference Value Sheet",
        "edit": "Edit",
        "delete": "Delete",
        "copy-as-new": "Copy as new",
        "copy-to-other-country": "Copy to another country"
      },
      "country": "Country"
    },
    "dialog": {
      "deleteConfirm": "Are you sure you want to delete this Reference Value Sheet?",
      "deleteConfirmWhenInUse": "This reference value sheet is linked to a cycle, are you sure you want to delete this reference value sheet?"
    },
    "create-from-standard": {
      "title": "Create Reference Value Sheet",
      "scratch-title": "Start from scratch",
      "scratch-option-title": "Start a reference value sheet",
      "scratch-button": "Start from scratch",
      "scratch-option-subtitle": "This is an empty reference value sheet",
      "reference-value-sheet-title": "Choose a reference value sheet as base",
      "reference-value-sheet-button": "Start with "
    },
    "create": {
      "print": "Print",
      "title": "Reference Value Sheet",
      "name": "Reference Value Sheet Name",
      "error-name": "Reference Value Sheet name is required",
      "add-one-day-values-row": "Add day",
      "number-of-days": "Days",
      "add-multiple-day-values-rows": "Add days",
      "description": "Description",
      "description-placeholder": "Reference Value Sheet description",
      "no-day-values-title": "The Reference Value Sheet is empty",
      "no-day-values-description": "Add days to the Reference Value Sheet below to start.",
      "table-header": {
        "day": "Day",
        "temperatureInside": "Temperature inside ",
        "relativeHumidity": "Relative Humidity (%)",
        "feedIntake": "Feed Intake ",
        "feedIntakePerChickPerDay": "Feed Intake ",
        "feedIntakeTotal": "Feed Intake Cum ",
        "feedIntakePerChickTotal": "Feed Intake Cum ",
        "waterIntake": "Water ",
        "weight": "Weight ",
        "mortality": "Mortality",
        "feedConversion": "Feed Conversion Cum",
        "waterToFeedRatio": "Water:feed Cum"
      },
      "created": "Created",
      "updated": "Updated",
      "validation-error": {
        "title": "Validation error(s)",
        "refvalsheet-name": "Reference Value Sheet Name is required."
      }
    },
    "print": {
      "farmcompany": "Farm Company",
      "customernr": "Customer number",
      "contactperson": "Contactperson",
      "location": "Location"
    },
    "select-country": {
      "title": "Select the country",
      "description": "Select the country you want to copy it to",
      "label": "Country"
    }
  },
  "reference-scheme": {
    "overview": {
      "title": "Reference Feed Advice Overview",
      "empty": {
        "title": "Reference feed advice items unavailable",
        "description": "There are no reference feed advice items available at this moment."
      },
      "table-header": {
        "name": "Name",
        "created": "Created",
        "updated": "Updated",
        "updatedAdvisorName": "Updated by",
        "isActive": "Active"
      },
      "buttons": {
        "add": "Create Reference Feed Advice",
        "edit": "Edit",
        "delete": "Delete"
      },
      "country": "Country"
    },
    "dialog": {
      "deleteConfirm": "Are you sure you want to delete this reference feed advice?"
    },
    "create": {
      "title": "Reference Feed advice",
      "name": "Reference feed advice name",
      "error-name": "A name for the reference feed advice is required.",
      "description": "Description",
      "description-placeholder": "Reference feed advice description",
      "product-placeholder": "- select a product -",
      "add-product": "Add product",
      "table-header": {
        "productName": "Product",
        "chickenWeightInGrams": "Chick weight (g)",
        "ageFrom": "Age from (days)",
        "ageTo": "Age to (days)",
        "totalFeed": "Feed intake (g)",
        "coreFeed": "Core (g)",
        "wheatFeed": "Wheat (g)",
        "comment": "Comments"
      },
      "created": "Created",
      "updated": "Updated"
    }
  },
  "product-title": "Products",
  "product-save": "Save product",
  "product-saved": "Product saved!",
  "product-overview": {
    "title": "Product Overview",
    "overview": {
      "productName": "Name",
      "productCode": "Product code",
      "phase": "Phases",
      "isActive": "Active",
      "productType-Feed": "Feed",
      "productType-Additive": "Additive",
      "productType": "Product type"
    },
    "no-products": {
      "title": "No products found",
      "description": "By clicking Add a product can be created."
    },
    "delete-confirmation-title": "Delete product",
    "delete-confirmation-message": "Are you sure you want to remove this product?",
    "delete-error-message": "We could not remove the product. Make sure the product is not used in a reference scheme.",
    "delete-error-in-use-message": "We could not remove the product, because it is in use in one or more feed advices.",
    "country": "Country",
    "delete-confirmation-message-when-in-use": "This Product is used in one or more feed advices, are you sure you want to remove this product?"
  },
  "create-product": {
    "title-create": "New Product",
    "title-edit": "Edit Product:",
    "product-name": "Product Name",
    "phases-label": "Phases",
    "product-code": "Product Code",
    "error-product-name": "Please fill in the name of the product.",
    "error-product-code": "Please fill in the product code of the product.",
    "error-code-name-already-in-use": "Please use a unique combination of name and code",
    "product-type": {
      "label": "Product type",
      "Feed": "Feed",
      "Additive": "Additive"
    },
    "error-product-type": "Product type is required."
  },
  "countries": {
    "BE": "Belgium",
    "DE": "Germany",
    "HU": "Hungary",
    "NL": "Netherlands",
    "PL": "Poland",
    "JO": "Jordan",
    "NG": "Nigeria",
    "JM": "Jamaica",
    "TZ": "Tanzania",
    "DA": "Germany-Agravis"
  },
  "save": "Save",
  "report-title": "Barn overview poultry",
  "report-name": "Flock-barn-report-",
  "report-headers": {
    "general": "General",
    "day-old-chicks": "Day old chicks",
    "total": "Total",
    "departures": "Departures",
    "balance": "Balance",
    "key-figures": "Key figures",
    "technical": "Technical",
    "financial": "Financial"
  },
  "report-columns": {
    "customer": "Customer",
    "location": "Location",
    "barn": "Barn",
    "breed": "Breed",
    "concept": "Concept",
    "start-date": "Start date",
    "date": "Date",
    "age": "Age [days]",
    "amount": "Amount",
    "price": "Price (excl. VAT)",
    "discount": "Discount (excl. VAT)",
    "delivered": "Delivered [kg]",
    "weight": "Weight [g]",
    "paid": "Paid [kg]",
    "rejected": "Rejected [%]",
    "feed-code": "Feed code",
    "feed-name": "Feed name",
    "consumption": "Consumption [kg]",
    "consumption-per-day-old-chick": "Consumption per day old chick [g]",
    "day-old-chicks": "Day old chicks (m²)",
    "drop-out-total": "Drop out total (%)",
    "avg-age": "Avg. age (days)",
    "avg-weight": "Avg. weight (g)",
    "deliveredkg-per-m2": "Delivered kg per m²",
    "growth": "Growth (g/d)",
    "feed-conversion": "Feed conversion",
    "feed-conversion-1500": "Feed conversion 1500",
    "replacement": "Replacement (%)",
    "avg-rejected": "Avg. rejected (%)",
    "production-number": "Production number",
    "price-per-delivered-chick": "Price per delivered chick (ct)",
    "feed-price-per-100": "Feed price per 100kg ",
    "feed-price-per-delivered-kg": "Feed price per delivered kg (ct)",
    "yield-per-kg": "Yield per kg",
    "feed-profit": "Feed ",
    "feed-profit-per-day-old-chick": "Feed profit per day old chick (ct)",
    "feed-profit-per-m2-per-day": "Feed profit per m² per day (ct)",
    "cycle-nr": "Cycle nr",
    "barns": "Barns",
    "netto-profit-incl-other-costs": "Netto profit including other costs",
    "discountLabel-ledenvoordeel": "Member benefit",
    "discountLabel-ledenkorting": "Member discount",
    "discountLabel-integratiepremie": "Integration premium",
    "discountLabel-nieuwbouwpremie": "New construction premium",
    "discountLabel-ncw": "Net present value distribution",
    "total-incl-discount": "Total (incl. discounts)",
    "discountLabel-korting": "Discount",
    "discountLabel-overig": "Other",
    "discountLabel-nabetaling": "Back payment",
    "discountLabel-correctievoerprijs": "Correction feedprice",
    "discountLabel-vergoedingvolgensafspraak": "Compensation per agreement",
    "feed-profit-per-m2": "Feed profit per m²"
  },
  "total": "Total",
  "days-short": "Days",
  "parent-stock-identifier": "Parent Stock ID",
  "import": "Import",
  "csv-import": {
    "delivery-success": "Deliveries imported successfully.",
    "departure-success": "Departures imported successfully.",
    "errors": {
      "amount-exceeds-remaining": "Row ${rowNumber}: Amount exceeds the remaining chicks for barn '${barn}'. Maximum allowed amount is ${maxAmount}.",
      "barn-not-found": "Row ${rowNumber}: Barn '${value}' was not found in the selected cycle.",
      "configured-slaughterhouses-could-not-be-loaded": "Configured slaughterhouses could not be loaded.",
      "cycle-could-not-be-loaded": "Cycle '${cycleId}' could not be loaded.",
      "cycle-invalid": "CSV departures are invalid for the selected cycle.",
      "cycle-not-found": "Cycle '${cycleId}' was not found for the current customer/location.",
      "date-before-first-arrival": "Row ${rowNumber}: Date must be on or after the first arrival date.",
      "date-in-future": "Row ${rowNumber}: Date cannot be in the future.",
      "duplicate-column": "CSV contains duplicate column '${column}'.",
      "file-empty": "CSV file is empty.",
      "file-required": "CSV file is required.",
      "file-too-large": "CSV file is too large. Maximum allowed size is ${maxSizeKb} KB.",
      "invalid-date": "Row ${rowNumber}: ${field} is required and must be a valid date.",
      "invalid-number": "Row ${rowNumber}: ${field} must be a valid number.",
      "missing-required-columns": "CSV is missing required column(s): ${columns}.",
      "no-data-rows": "CSV must contain at least one data row.",
      "required-field": "Row ${rowNumber}: ${field} is required.",
      "required-positive-whole-number": "Row ${rowNumber}: ${field} is required and must be a positive whole number.",
      "required-valid-number": "Row ${rowNumber}: ${field} is required and must be a valid number.",
      "skip-import-invalid": "Row ${rowNumber}: Skip import must be empty or one of yes, no, true, false, 1, 0, x.",
      "slaughterhouse-not-found": "Row ${rowNumber}: Slaughterhouse '${value}' was not found.",
      "too-many-rows": "CSV contains too many rows. Maximum allowed rows is ${maxRows}.",
      "total-slaughterweight-higher-than-departure-weight": "Row ${rowNumber}: Total slaughterweight cannot be higher than Departure weight.",
      "type-invalid": "Row ${rowNumber}: Type is required and must be Full or Partial.",
      "unterminated-quote": "CSV contains a value with an opening quote that is missing its closing quote.",
      "unknown": "CSV import failed.",
      "unsupported-file-type": "Only CSV files are supported."
    },
    "download-template": "Download template",
    "invalid-file": "Select a valid CSV file.",
    "upload": "Upload CSV"
  },
  "slaughter-report": "Slaughter report",
  "link-slaughter-results-title": "Link slaughter results",
  "link-slaughter-results-description": "Select a barn per slaughter report. For each slaughter report, one departure row will be created.",
  "slaughter-date": "Slaughter date",
  "number-of-chickens": "Number of chickens",
  "departure-weight-kg": "Departure weight (kg)",
  "show-financial-data": "Show financial data",
  "financial-results": "Financial results",
  "link-to-barn": "Link to barn",
  "imported-slaughter-report-label": "Imported slaughter report",
  "slaughter-weight-kg": "Slaughter weight (kg)",
  "veterinary": "Veterinary",
  "employment": "Employee",
  "otherRevenue": "Other revenue",
  "otherCosts": "Other costs",
  "discount-title": "Discounts",
  "discount-label": "Discount label",
  "discount-applicabilityType": "Applies to",
  "discount-amount": "Amount, excl. VAT",
  "discount-item": {
    "applicabilityType-arrivalcost": "Arrival costs",
    "applicabilityType-feedcost": "Feed costs",
    "applicabilityType-departurerevenue": "Departure revenue",
    "add-discount": "Add discount",
    "labelType-ledenvoordeel": "Member benefit",
    "labelType-ledenkorting": "Member discount",
    "labelType-integratiepremie": "Integration premium",
    "labelType-nieuwbouwpremie": "New construction premium",
    "labelType-ncw": "Net present value distribution",
    "labelType-korting": "Discount",
    "labelType-overig": "Other",
    "labelType-nabetaling": "Back payment",
    "labelType-correctievoerprijs": "Correction feedprice",
    "labelType-vergoedingvolgensafspraak": "Compensation per agreement"
  },
  "discount": {
    "no-discounts-title": "There are no discounts yet.",
    "no-discounts-description": "Add a discount and it will be shown here."
  },
  "delete-item-discount": "Do you want to remove the discount?",
  "farm-result": {
    "table-header": {
      "sensorActuator": "Sensor/Actuator Id",
      "barn": "Barn",
      "sensorActuatorName": "Sensor/Actuator Name",
      "farmResultLocationId": "Location Id"
    },
    "select-barn-placeholder": "- select a barn -"
  },
  "discountLabel-korting": "Discount",
  "discountLabel-overig": "Other",
  "discountLabel-nabetaling": "Back payment",
  "discountLabel-correctievoerprijs": "Correction feedprice",
  "discountLabel-vergoedingvolgensafspraak": "Compensation per agreement",
  "delete-item-day-old-chick-used-in-balance": "This delivery is currently used on the balance. Should you choose to delete this delivery, then the balance must be recalculated. Do you want to delete the delivery?",
  "edit-day-old-chick_barn-used-in-balance": "You are changing a barn that is being used on the balance. If you save this change, then the balance must be recalculated. Do you want to continue?",
  "cycle-description": "Description",
  "confirm": "Submit",
  "interval-type-Day": "Day",
  "interval-type-Week": "Week",
  "unitOfMeasure-setting": {
    "title": "Unit of measure",
    "warning": "Changing the Unit of measure settings can result in small value differences caused by mathematical rounding.",
    "waterIntakeUnit": "Water Intake Unit",
    "CumulativeLiter": "Cumulative L",
    "MililiterPerBird": "Ml per animal",
    "feedIntakeUnit": "Feed Intake Unit",
    "CumulativeKilogram": "Cumulative Kg",
    "GramPerBird": "Gram per animal"
  },
  "error-amount-of-chicks-minimum": "The minimum amount of chicks is:",
  "animal-group": {
    "animalGroupTitle": "Animal Group",
    "switchDay": "Switch Day",
    "addSwitchDay": "Add Switch Day",
    "phaseFrom": "Phase From",
    "phaseTo": "Phase To",
    "date": "Date",
    "medication": "Medication",
    "treatmentDateStart": "Treatment Start",
    "treatmentDateEnd": "Treatment End",
    "addMedication": "Add Medication",
    "diagnose": "Diagnose",
    "quantity": "Quantity",
    "unit": "Unit",
    "quantityUnitDescriptions": {
      "kilogram": "Kilograms",
      "gramsPerLitre": "Grams per litre",
      "percentage": "Percentage",
      "gram": "Grams",
      "noUnit": "No unit",
      "gramsPerKilogram": "Grams per kilogram",
      "milligram": "Milligrams",
      "milligramsPerKilogram": "Milligrams per kilogram"
    },
    "vaccination": "Vaccination",
    "addVaccination": "Add Vaccination",
    "vaccine": "Vaccine",
    "poultryDisease": "Poultry Disease",
    "vaccinationMethod": "Vaccination Method",
    "validationDialogTitle": "Required information",
    "validationDialogMessage": "Please add the required information in the tables",
    "veterinarianTitle": "Veterinarian"
  },
  "final-setup-setting": {
    "switch": "Final Setup",
    "chick-delivery-switch": "Chicks Deliveries",
    "feed-delivery-switch": "Feed Deliveries",
    "departure-switch": "Departures",
    "discount-switch": "Discounts",
    "title": "Final Setup",
    "default-settings-title": "Default Settings",
    "masterdata": {
      "title": "Masterdata",
      "notes": "Notes",
      "payer": "Payer",
      "payer-email": "Payer email",
      "representative-agrifirm": "Representative <Tenant>",
      "separate-stable": "Separate Stable",
      "integration-premium": "Integration premium",
      "discount-value": "value of discount",
      "agrifirm-member": "<Tenant> member"
    }
  },
  "invoice-date": "Invoice date",
  "invoice-number": "Invoice number",
  "vat-percentage": "VAT Percentage",
  "vat": "VAT (%)",
  "amount-including-vat": "Amount including VAT (€)",
  "final-setup": {
    "chick-deliveries": "Chicks Deliveries",
    "empty-chick-deliveries-title": "No chick deliveries",
    "empty-chick-deliveries-description": "No chick deliveries",
    "day-old-chick": "Day-old chicks",
    "feed-deliveries": "Feed deliveries",
    "empty-feed-deliveries-title": "No feed deliveries",
    "empty-feed-deliveries-description": "No feed deliveries",
    "empty-departures-description": "No departures",
    "departures": "Departures",
    "empty-departures-title": "No departures",
    "discounts": "Discounts",
    "empty-discounts-title": "No discounts",
    "empty-discounts-description": "No discounts",
    "print-footer": "All agreements entered into and products and/or services supplied by us are exclusively subject to the General Terms and Conditions of Delivery of Agrifirm NWE BV. These will be sent to you free of charge upon first request and can also be consulted and saved via: https://www .agrifirm.nl/globalassets/agrifirm-group/agrifirm-nl/leveringsvoorwaarden/general-terms--nl.pdf​",
    "print-footer-agravis": "All agreements entered into and products and/or services supplied by us are exclusively subject to the General Terms and Conditions of Delivery of Agravis. These will be sent to you free of charge upon first request.",
    "print-description": "Description",
    "print-message-line-1": "Dear sir, madam,",
    "print-message-line-2": "We will send you an overview of the invoices for the past round.",
    "print-end-line-1": "The above overview must correspond with your administration.",
    "print-end-line-2": "Kind regards,",
    "print-company-name": "Agrifirm NWE BV",
    "print-company-name-agravis": "Agravis",
    "print-company-email": "Email: kengetallenadministratie@agrifirm.com",
    "print-company-email-agravis": "Email: info@agravis.nl",
    "print-company-phone": "Phone: 088 - 488 2976",
    "print-company-phone-agravis": "",
    "print-to-receive": "For you to receive",
    "print-total-feed": "Total feed, see attachment for specification",
    "print-invoice-number": "Invoice no.",
    "print-amount-excluding-vat": "Amount excluding VAT",
    "print-vat-amount": "VAT",
    "print-amount-including-vat": "Amount including VAT",
    "print-product": "Product",
    "print-net-weight": "Net (kg)",
    "include-in-calculations-label": "Include in calculations",
    "print-to-pay": "For you to pay",
    "print-payment-terms": "We kindly request that you pay the above amount within 14 days, stating your customer number, to bank account NL.86.RABO.010.10.50.003.",
    "print-subtotal": "Subtotal",
    "feed-delivery-end-date": "Final setup cycle end date",
    "additional-invoices": "Additional Invoices (Exlan etc.)",
    "empty-additional-invoices-title": "No additional invoices",
    "empty-additional-invoices-description": "No additional invoices",
    "additional-invoices-add": "Add Invoice",
    "additional-invoices-delete-confirm-title": "Remove Additional Invoice",
    "additional-invoices-delete-confirm-description": "Are you sure you want to remove this invoice?",
    "fixed-price": "Fixed price agreement",
    "fixed-price-per-100": "Price per 100 kg",
    "fixed-price-correction": "Price correction based on fixed price",
    "price-agreement": "price agreement",
    "per-100-kg": "/ 100 kg excl. VAT."
  },
  "amount-excluding-vat": "Amount, excl. VAT (€)",
  "discount-description": "Description",
  "discount-showInFinalSetup": "Show in Final Setup",
  "label": "Label",
  "link-slaughter-invoices-description": "Select the invoices that need to be linked to the cycle. For each invoice, one row will be created in the final setup.",
  "link-slaughter-invoices-title": "Link slaughter invoices",
  "slaughter-invoice": "Slaughter invoice",
  "vaccination-price": "Vaccination price per chick, excl. VAT",
  "discount-price": "Discount per chick, excl. VAT",
  "diverse-price": "Diverse cost per chick, excl. VAT",
  "total-price-including-vat": "Amount, incl. VAT",
  "total-calculated-amount": "Total amount, excl. VAT",
  "total-calculated-amount-including-vat": "Total amount, incl. VAT",
  "arrival-notification-cycle-overview": "The net price per vaccination and miscellaneous items per chick are included in the financial overview, where the total can be found",
  "arrival-notification-final-setup": "The net price per vaccination and miscellaneous items per chick are included in the financial overview, where the total can be found",
  "edit-day-old-chick": "Edit Delivery",
  "edit-departure": "Edit Departure",
  "of-delivery": "of Delivery",
  "delivery-date": "Delivery date",
  "delivery-number": "Delivery ID",
  "base-quantity": "Quantity (kg)",
  "discount-setting": {
    "title": "Discounts",
    "memberDiscountNL": "Member discount (€)",
    "memberBenefitNL": "Member benefit (%)",
    "memberBenefitAbroad": "Member benefit abroad (%)",
    "warning-title": "Beware!",
    "warning-message": "These values ​​are used for all customers and locations. Do not change them."
  },
  "sustainability": {
    "calculations": {
      "source": "Source",
      "value": "Value",
      "unit": "Unit",
      "description": "View previous calculations or calculate another cycle.",
      "new": "New calculation",
      "result": "Saved result",
      "history": "Previous calculations",
      "last-updated": "Last updated",
      "history-description": "Select a calculation to view its result.",
      "calculation": "Calculation",
      "view-result": "View result",
      "empty": "No calculations saved for this cycle yet.",
      "select-cycle": "Select a cycle to view its saved calculations.",
      "loading": "Loading calculations…",
      "load-error": "Calculations could not be loaded. Try again.",
      "retry": "Try again",
      "pending": "This calculation is still processing. Refresh the result later.",
      "calculating": "Importing feeds and calculating the carbon footprint…",
      "result-failed": "This calculation failed. Check the requirements in the calculation panel, then try again. If this continues, contact your advisor.",
      "attempt-failed": "The latest attempt failed. Check the requirements below, then try again. Previous saved results remain available.",
      "status": {
        "complete": "Calculated",
        "pending": "Processing",
        "failed": "Failed"
      }
    },
    "readiness": {
      "view-details": "View feed-data details",
      "requirements-met": "requirements met",
      "title": "Requirements",
      "checking": "Checking required data…",
      "error": "Required data could not be checked. Try again.",
      "ready": "Required data complete.",
      "blocked": "Complete the items below before calculating.",
      "complete": "Complete",
      "action-required": "Action required",
      "edit-arrivals": "Edit arrivals",
      "edit-departures": "Edit departures",
      "edit-resources": "Edit energy per year",
      "edit-bedding": "Edit bedding",
      "advisor": "Contact your advisor to correct this data. Share the product and delivery details shown above.",
      "disclaimer": "This check validates required data. Sustell can still reject the calculation.",
      "recheck": "Check again",
      "calculation-failed": "Sustell could not calculate this footprint. Check the requirements below, then try again. If this continues, contact your advisor.",
      "requirements": {
        "cycle": "Arrivals, departures and valid dates",
        "farm-resources": "Energy for every required year",
        "bedding": "Bedding details",
        "feeds": "Feed nutrition and emissions"
      },
      "arrival-weight": "Average arrival weight per bird",
      "departure-weight": "Average departure weight per bird",
      "issues": {
        "feeds-missing": "Register compound feed consumption in this cycle's feed balance.",
        "arrivals-missing": "Register the chick arrivals.",
        "departures-missing": "Register the departures.",
        "cycle-dates-invalid": "Correct the cycle, arrival and departure dates.",
        "arrival-data-invalid": "Enter a positive bird count and arrival weight in grams per bird.",
        "departure-data-invalid": "Enter a positive bird count and total departure weight in kg.",
        "departure-weight-below-arrival": "Average departure weight must be at least the average arrival weight. Check arrival weight in grams per bird, total departure weight in kg, and bird counts.",
        "farm-resources-missing": "Register energy consumption for year",
        "cycle-dates-required": "Register valid arrivals and departures so required years can be checked.",
        "bedding-type-missing": "Select a bedding type.",
        "bedding-amount-missing": "Enter the bedding amount.",
        "ship-to-missing": "The delivery location is not linked to the feed supplier.",
        "delivery-missing": "Delivery data is unavailable.",
        "delivery-line-missing": "The delivery product data is unavailable.",
        "feed-data-invalid": "Required feed data is missing or invalid.",
        "feed-settings-missing": "Feed import settings are incomplete.",
        "farm-resources-not-calculated": "Save the energy records again to allocate consumption to this cycle."
      },
      "fields": {
        "Consumption": "Feed consumption (kg), greater than zero",
        "Co2Total": "Total carbon footprint",
        "Co2TotalMismatch": "Total CO₂ does not match the sum of biogenic, fossil and land-use change emissions. Ask your advisor to correct the feed data.",
        "Biogenic": "Biogenic emissions",
        "FossilExcludingPeatEmissions": "Fossil emissions excluding peat",
        "FossilPeatEmissions": "Peat emissions",
        "LandUseChange": "Land-use change emissions",
        "DryMatterAmount": "Dry matter content",
        "RoughProtein": "Protein content",
        "ProductIdentifier": "Product reference"
      },
      "edit-feeds": "Edit feed balance",
      "edit-cycle": "Edit cycle"
    },
    "sustainability": "Sustainability",
    "farm-resources": "Energy per year",
    "carbon-footprint": "Carbon footprint",
    "add-farm-resources": "Add farm resources",
    "confirm-delete-farm-resource": "Delete the farm resource?",
    "farm-resource-deleted": "Farm resource deleted",
    "farm-resource-saved": "Farm resource saved",
    "year": "Year",
    "farm-settings-saved": "Farm settings saved",
    "farm-settings-enable-co2-calculation": "Enable CO2 calculations for this farm",
    "resource": {
      "electricity": "Electricity (kWh)",
      "electricity-photovoltaic": "Electricity Sun (kWh)",
      "electricity-wind": "Electricity Wind (kWh)",
      "natural-gas": "Natural gas (m³)",
      "diesel": "Diesel (L)",
      "gasoline": "Gasoline (L)",
      "coal": "Coal (KG)",
      "propane-lpg": "Propane / LPG (L)",
      "water": "Water (m³)",
      "cycle-start-date": "Start date",
      "cycle-end-date": "End date",
      "status": "Status",
      "statuses": {
        "complete": "Complete",
        "partial": "Partial"
      },
      "water-error": "Water must be a positive number",
      "electricity-error": "Electricity must be a positive number",
      "electricity-photovoltaic-error": "Electricity sun must be a positive number",
      "electricity-wind-error": "Electricity wind must be a positive number",
      "natural-gas-error": "Natural gas must be a positive number",
      "diesel-error": "Diesel must be a positive number",
      "gasoline-error": "Gasoline must be a positive number",
      "propane-lpg-error": "Propane / LPG must be a positive number",
      "coal-error": "Coal must be a positive number"
    },
    "farm-resources-title": "Energy consumption per year",
    "cycle-resources": "Cycle resources",
    "value": "Value live weight (kg CO2eq / kg body weight)",
    "notification-title": "Important information about CO2 calculations",
    "notification-description": "The calculation of the carbon footprint is powered by LCA software Sustell. As background the CO2 feed calculations are performed in accordance with the current Nevedi instruction. To supply a correct calculation, all data needs to be entered completely such as <b>technical results of a flock incl. production and departure/slaughter and energy consumption.</b>\nDisplayed values may be subject to change due to adaptation of climate science and subsequent changes in calculation systems, as well as changes in laws and regulations and any applicable standards. Although the information shown here has been compiled with care, no rights may be derived from it.",
    "action-text-close": "Hide",
    "action-text-open": "Show",
    "farm-resources-not-complete": "Cycle resources are not complete.",
    "bedding-type-required": "Bedding type is required for the cycle.",
    "bedding-amount-required": "Bedding amount is required for the cycle.",
    "start-calculation": "Start calculating CO2",
    "refresh-carbon-footprint": "Refresh CO2 footprint",
    "carbon-footprint-title-error": "Carbon Footprint Calculation Error",
    "carbon-footprint-title": "Carbon Footprint Calculation",
    "carbon-footprint-text": "The carbon footprint calculation will start. Please be patient while the process completes (approximately 1 minute).",
    "carbon-footprint-refresh-error-title": "Could not refresh CO2 footprint",
    "carbon-footprint-refresh-error-text": "We could not refresh the CO2 footprint. Please try again in a moment."
  },
  "bedding-type": "Bedding type",
  "bedding-types": {
    "NoBedding": "No bedding",
    "BarleyStraw": "Barley straw",
    "MaizeStover": "Maize stover",
    "OatStraw": "Oat straw",
    "SawDust": "Saw dust",
    "SunflowerHusk": "Sunflower husk",
    "WheatStraw": "Wheat straw",
    "Woodshavings": "Wood shavings"
  },
  "bedding-amount": "Bedding amount",
  "bedding-amount-error": "Bedding amount must be a positive number",
  "transport-distance": "Transport from hatchery",
  "transport-distance-error": "Transport from rearing facility must be a number between 0 and 1000",
  "time-in-free-range": "Time in free range",
  "time-in-free-range-error": "Time in free range must be a number between 0 and 100",
  "general-settings-error": "An error occurred while retrieving settings for PoultryNEXT.",
  "tenants": {
    "Agrifirm": "agrifirm",
    "Agravis": "agravis"
  }
}
